const useStyles = (theme, imgSelected, isDragging) => ({
  dropZone: {
    border: `2px dashed ${
      isDragging ? theme.palette.primary.main : theme.palette.divider
    }`,
    borderRadius: 2,
    p: { xs: 1, sm: 4 },
    textAlign: "center",
    cursor: "pointer",
    transition: "0.3s",
    bgcolor: isDragging ? "hsl(var(--accent) / 0.1)" : "transparent",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      bgcolor: "hsl(var(--accent) / 0.05)",
    },
  },
  dialogPaper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    maxHeight: "100vh",
    backgroundColor: "transparent",
    boxShadow: "none",
    p: 0,
    maxHeight: "95vh",
  },
  mainPanel: {
    position: "relative",
    flex: 2,
    display: imgSelected ? { xs: "none", md: "flex" } : "flex",
    flexDirection: "column",
    p: 3,
    maxWidth: { xs: "95vw", sm: "600px" },
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid " + theme.palette.divider,
  },
  titleBox: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  deleteButton: {
    position: "absolute",
    top: 4,
    right: 4,
    bgcolor: "rgba(0,0,0,0.7)",
    color: "error.main",
    "&:hover": { transform: "scale(1.1)", bgcolor: "rgba(0,0,0,0.9)" },
  },
  editButton: {
    position: "absolute",
    top: 40,
    right: 4,
    bgcolor: "rgba(0,0,0,0.7)",
    color: "white",
    "&:hover": { transform: "scale(1.1)", bgcolor: "rgba(0,0,0,0.9)" },
  },
  errorIcon: {
    color: "error.main",
    position: "absolute",
    top: 5,
    left: 5,
    fontSize: 25,
    animation: "pulse 1s infinite",
    "@keyframes pulse": {
      "0%, 100%": { transform: "scale(1)" },
      "50%": { transform: "scale(1.2)" },
    },
  },
  fileName: {
    position: "absolute",
    bottom: 4,
    left: 4,
    color: "white",
    bgcolor: "rgba(0,0,0,0.6)",
    px: 0.5,
    borderRadius: 1,
    maxWidth: "90%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  previewGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(110px, 115px))",
    gap: 2,
    mt: 2,
    maxHeight: "calc(100vh - 520px)",
    overflowY: "auto",
    p: 1,
  },
  previewItem: {
    position: "relative",
    paddingTop: "100%",
    borderRadius: 2,
    overflow: "hidden",
    border: (f) =>
      `1px solid ${f.error ? theme.palette.error.main : theme.palette.divider}`,
  },
  previewImage: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  progressCaption: {
    display: "block",
    textAlign: "center",
    mt: 1,
  },
  dialogActions: {
    mt: 2,
    gap: 1,
  },
  cropperPanel: {
    maxWidth: "300px",
    minHeight: "530px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    p: 3,
    position: "relative",
  },
  cropperContainer: {
    margin: "0 auto",
    width: 200,
    height: 200,
    position: "relative",
  },
  actionButtons: {
    position: "absolute",
    bottom: 20,
    right: 16,
  },
  TitleDrop: {
    fontSize: { xs: "1em", sm: "1.2rem" },
    fontWeight: 500,
    lineHeight: 1.4,
    letterSpacing: "0.02em",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.background.paperLinkedMaps,
      boxShadow: "none",
      width: "100%",
      "&:hover": {
        transform: "scale(1.02)",
        backgroundColor: theme.palette.background.paperLinkedMaps,
      },
    },
  },
});

export default useStyles;
